// Function to transform the data to display in the table
export const transformData = (data) => {
  // Extract the id and name
  const { id, forename, surname, phoneNumber, emailAddress } = data;
  // Return the transformed object
  return {
    id: id,
    name: `${forename} ${surname}`,
    features: transformFeatures(data),
    phone: phoneNumber,
    email: emailAddress,
  };
};

export const transformFeatures = (item) => {
  return [
    item.gender?.name,
    item.ageRange?.name,
    item.height?.name,
    item.build?.name,
    item.hair?.name,
    item.ethnicity?.name,
    item.features,
  ]
    .filter(Boolean)
    .join(", ");
};

export const appendPlaceholders = (newIdentityData) => {
  return {
    address1: "",
    address2: "",
    town: "",
    postcode: "",
    phoneNumber: "",
    emailAddress: "",
    hasBeenModified: false,
    rowVersion: "",
    ...newIdentityData,
  };
};
